export function getDateTimeValue(value) {
    if (!value) {
        return undefined;
    }
    return 'start' in value && 'end' in value ? value.start : value;
}
